import React from "react";
import "./Complete.css";

const Complete = () => {
    return (
        <div className="complete">
            <p>Completed All Trials</p>
            <p>You May Close the Window</p>
        </div>
    )
}

export default Complete;